export default function match(value, { match, bothDefined = false, locale = {} }) {
  const defined = bothDefined ? value && value.length && match && match.length : !bothDefined;

  if (defined && value !== match) {
    return locale.match || 'match';
  }

  return null;
}
